import { SaveReportSelectIntervalContentForm } from './SaveReportSelectIntervalContentForm';

export default SaveReportSelectIntervalContentForm;
